enum ConsentType {
  COMMUNICATION = 'communication',
}
export default ConsentType;
